import { WAVE_REACTION_PALETTE } from "./types.js";
export const WAVE_CHAT_REACTION_PALETTE = WAVE_REACTION_PALETTE;
export var WaveChatAuthorKind;
(function (WaveChatAuthorKind) {
    WaveChatAuthorKind["Human"] = "HUMAN";
    WaveChatAuthorKind["Agent"] = "AGENT";
})(WaveChatAuthorKind || (WaveChatAuthorKind = {}));
export var WaveChatMessageStatus;
(function (WaveChatMessageStatus) {
    WaveChatMessageStatus["Sent"] = "SENT";
    WaveChatMessageStatus["Pending"] = "PENDING";
    WaveChatMessageStatus["Failed"] = "FAILED";
})(WaveChatMessageStatus || (WaveChatMessageStatus = {}));
export const WAVE_CHAT_AGENT_MENTION = "@assistente";
export const WAVE_CHAT_AGENT_SUB = "agent:assistant";
export const WAVE_CHAT_AGENT_NAME = "Assistente";
export function parseWaveChatAuthorKind(raw) {
    return raw === WaveChatAuthorKind.Agent
        ? WaveChatAuthorKind.Agent
        : WaveChatAuthorKind.Human;
}
export function parseWaveChatMessageStatus(raw) {
    if (raw === WaveChatMessageStatus.Pending)
        return WaveChatMessageStatus.Pending;
    if (raw === WaveChatMessageStatus.Failed)
        return WaveChatMessageStatus.Failed;
    return WaveChatMessageStatus.Sent;
}
export function chatMentionsAssistant(body) {
    return body.toLowerCase().includes(WAVE_CHAT_AGENT_MENTION);
}
export function unreadChatCount(messages, lastReadAt, currentSub) {
    const cutoff = lastReadAt ? Date.parse(lastReadAt) : 0;
    let count = 0;
    for (const msg of messages) {
        if (msg.authorSub === currentSub)
            continue;
        const ts = Date.parse(msg.createdAt);
        if (!Number.isFinite(ts))
            continue;
        if (ts > cutoff)
            count += 1;
    }
    return count;
}
/** One-level thread grouping (Slack-style): roots + replies; deep replies promoted to root. */
export function buildChatThreads(messages) {
    const byId = new Map();
    for (const msg of messages) {
        byId.set(msg.messageId, msg);
    }
    const roots = [];
    const repliesByRoot = new Map();
    for (const msg of messages) {
        if (!msg.parentId) {
            roots.push(msg);
            continue;
        }
        const parent = byId.get(msg.parentId);
        const rootId = parent?.parentId ? (parent.parentId ?? parent.messageId) : (parent?.messageId ?? msg.parentId);
        const bucket = repliesByRoot.get(rootId) ?? [];
        bucket.push(msg);
        repliesByRoot.set(rootId, bucket);
    }
    roots.sort((a, b) => Date.parse(a.createdAt) - Date.parse(b.createdAt));
    return roots.map((root) => {
        const replies = (repliesByRoot.get(root.messageId) ?? []).slice();
        replies.sort((a, b) => Date.parse(a.createdAt) - Date.parse(b.createdAt));
        return { root, replies };
    });
}
export function aggregateReactionCounts(counts) {
    const out = {};
    for (const row of counts) {
        if (row.count > 0)
            out[row.emoji] = row.count;
    }
    return out;
}
export function isWaveChatReactionEmoji(value) {
    return WAVE_CHAT_REACTION_PALETTE.includes(value);
}
export function mergeChatMessage(prev, incoming) {
    const idx = prev.findIndex((m) => m.messageId === incoming.messageId);
    if (idx >= 0) {
        const next = prev.slice();
        next[idx] = { ...next[idx], ...incoming };
        return next;
    }
    const next = [...prev, incoming];
    next.sort((a, b) => Date.parse(a.createdAt) - Date.parse(b.createdAt));
    return next;
}
export function formatChatTime(iso) {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime()))
        return "";
    return d.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" });
}
